import React, { useMemo } from "react";
import { Table } from "../../../../../shared/Table/Table";
import classes from "../../../newBusinessInsightsContent.module.scss";
import { useNetSalesReport } from "./hooks/useNetSalesReport";
import Header from "../../../components/Header";
import { useHeaderActions } from "../../../hooks/useHeaderActions";
import { Box } from "../../../../../shared/Box/Box";
import { Skeleton } from "../../../../../shared/Skeleton/Skeleton";
import { Empty } from "../../../../../shared/Empty/Empty";
import { HTTP_ENDPOINTS } from "../../../../../consts/api";

const modalInfo = {
  title: "netSalesReport.info.title",
  rows: [
    "netSalesReport.info.providerSales",
    "netSalesReport.info.clinicSales",
  ],
};

const NetSalesReport = () => {
  const { selectedClinic, period, apiPeriod } = useHeaderActions();
  const requestParams = {
    fromDate: apiPeriod.fromDate,
    toDate: apiPeriod.toDate,
    clinic_id:
      selectedClinic.value.value !== 0 ? [selectedClinic.value.value] : [],
  };
  const { data, isLoading } = useNetSalesReport(requestParams);

  const isProviderDataEmpty = !isLoading && !data?.providerNetSales?.length;
  const isClinicDataEmpty = !isLoading && !data?.clinicNetSales?.length;

  const providerData = useMemo(
    () =>
      data?.providerNetSales?.map((provider) => ({
        providerName: provider.provider_name,
        netSales: provider.net_sales,
      })) || [],
    [data],
  );

  const clinicData = useMemo(
    () =>
      data?.clinicNetSales?.map((clinic) => ({
        clinicName: clinic.clinic_name,
        netSales: clinic.net_sales,
      })) || [],
    [data],
  );

  return (
    <div className="flex-col font-14 gap-16">
      <Header
        title="Net Sales Report"
        selectedClinic={selectedClinic}
        period={period}
        downloadRoute={HTTP_ENDPOINTS.getNetSalesReport()}
        requestParams={requestParams}
        modalInfo={modalInfo}
      />
      <div className="flex-col gap-16">
        <div className={classes.tableContainer}>
          <Table
            bgColor="white"
            cols={[
              { data: "Provider Name", accessor: "providerName" },
              { data: "Net Sales", accessor: "netSales" },
            ]}
            data={providerData}
          />
          {isLoading && (
            <Box>
              <Skeleton count={8} height={40.5} borderRadius="0px" />
            </Box>
          )}
          {isProviderDataEmpty && (
            <Box>
              <Empty position="center" />
            </Box>
          )}
        </div>
        <div className={classes.tableContainer}>
          <Table
            bgColor="white"
            cols={[
              { data: "Clinic Name", accessor: "clinicName" },
              { data: "Net Sales", accessor: "netSales" },
            ]}
            data={clinicData}
          />
          {isLoading && (
            <Box>
              <Skeleton count={8} height={40.5} borderRadius="0px" />
            </Box>
          )}
          {isClinicDataEmpty && (
            <Box>
              <Empty position="center" />
            </Box>
          )}
        </div>
      </div>
    </div>
  );
};

export default NetSalesReport;
